/*
 * Silver Gardens — Configured Cart Behaviour
 *
 * Purpose:
 * - Plant quantity changes also update the linked Pot quantity.
 * - Removing the Plant removes the Plant, linked Pot, and finishing items.
 * - Finishing items such as Pebbles remain independently removable.
 * - Normal cart items keep Stiletto's native behaviour.
 */

(function () {
  if (window.SGConfiguredCart && window.SGConfiguredCart.ready) {
    return;
  }

  window.SGConfiguredCart = {
    ready: true
  };

  function shopRoot() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function showError(item, message) {
    if (!item) return;

    var error = item.querySelector(".quick-cart__item-error");

    if (!error) return;

    error.textContent =
      message || "Unable to update your cart. Please try again.";

    error.classList.remove("hidden");
  }

  function setBusy(group, busy) {
    if (!group) return;

    group.dataset.sgCartBusy = busy ? "true" : "false";

    group
      .querySelectorAll(
        '[data-sg-role="plant"] [data-add-quantity], ' +
        '[data-sg-role="plant"] [data-subtract-quantity], ' +
        '[data-sg-role="plant"] [data-remove-item]'
      )
      .forEach(function (button) {
        button.disabled = !!busy;
      });
  }

  function configuredUpdates(group, quantity) {
    var updates = {};

    var plant = group.querySelector(
      '[data-input-item][data-sg-role="plant"]'
    );

    if (!plant || !plant.dataset.key) {
      return null;
    }

    updates[plant.dataset.key] = quantity;

    var pot = group.querySelector(
      '[data-input-item][data-sg-role="pot"]'
    );

    if (pot && pot.dataset.key) {
      updates[pot.dataset.key] = quantity;
    }

    if (quantity === 0) {
      group
        .querySelectorAll(
          '[data-input-item][data-sg-role="finish"]'
        )
        .forEach(function (finish) {
          if (finish.dataset.key) {
            updates[finish.dataset.key] = 0;
          }
        });
    }

    return updates;
  }

  function updateConfiguredGroup(group, quantity, plantItem) {
    if (
      !group ||
      group.dataset.sgCartBusy === "true"
    ) {
      return;
    }

    var updates = configuredUpdates(group, quantity);

    if (!updates) {
      return;
    }

    setBusy(group, true);

    fetch(shopRoot() + "cart/update.js", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        updates: updates
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response
            .json()
            .catch(function () {
              return {};
            })
            .then(function (data) {
              throw new Error(
                data.description ||
                data.message ||
                "Unable to update your cart."
              );
            });
        }

        return response.json();
      })
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent("apps:product-added-to-cart", {
            detail: {
              source: "configured-cart",
              cart: cart
            }
          })
        );

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: {
              cart: cart
            }
          })
        );
      })
      .catch(function (error) {
        console.error(
          "Configured cart update failed:",
          error
        );

        showError(
          plantItem,
          error.message ||
          "Unable to update your cart. Please try again."
        );
      })
      .finally(function () {
        setBusy(group, false);
      });
  }

  function handleConfiguredCartClick(event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    var control = event.target.closest(
      "[data-add-quantity], " +
      "[data-subtract-quantity], " +
      "[data-remove-item]"
    );

    if (!control) {
      return;
    }

    var plantItem = control.closest(
      '[data-input-item][data-sg-role="plant"]'
    );

    if (!plantItem) {
      return;
    }

    var group = plantItem.closest(
      "[data-sg-cart-group]"
    );

    if (!group) {
      return;
    }

    var nextQuantity = null;

    if (control.matches("[data-remove-item]")) {
      nextQuantity = 0;
    } else {
      var input = plantItem.querySelector(
        "[data-quantity-input]"
      );

      if (!input) {
        return;
      }

      var currentQuantity = parseInt(
        input.value,
        10
      );

      if (!Number.isFinite(currentQuantity)) {
        return;
      }

      if (control.matches("[data-add-quantity]")) {
        nextQuantity = currentQuantity + 1;
      }

      if (control.matches("[data-subtract-quantity]")) {
        nextQuantity = Math.max(
          0,
          currentQuantity - 1
        );
      }
    }

    if (nextQuantity === null) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    updateConfiguredGroup(
      group,
      nextQuantity,
      plantItem
    );
  }

  document.addEventListener(
    "click",
    handleConfiguredCartClick,
    true
  );
})();